import { render, staticRenderFns } from "./AdminReports.html?vue&type=template&id=2028e467&scoped=true&"
import script from "./AdminReports.vue?vue&type=script&lang=js&"
export * from "./AdminReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminReports.scss?vue&type=style&index=0&id=2028e467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028e467",
  null
  
)

export default component.exports